import { useEffect, useRef, useState } from "react";
import { Platform, TextInput } from "react-native";
import { ios, web } from "./Platform";
import { capitalizeFirstLetter, cleanValue } from "./CommonFunctions";

export default function CustomTextInput(props) {
  let {
    style,
    onChangeText,
    value,
    placeholder,
    isCurrency = false,
    keyboardType,
    secureTextEntry,
    border,
    onBlur = () => {},
    onKeyPress = () => {},
    onFocus = () => {},
    ref,
    formatZero = false,
    maxLength = null,
  } = props;

  keyboardType = isCurrency ? "numeric" : keyboardType;

  let { autoCapitalize } = props;

  const [InputStyle, setInputStyle] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [hoverStyle] = useState(
    Platform.select({
      ios: {
        shadowColor: "rgba(0, 0, 0, 0.4)",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.8,
        shadowRadius: 4,
      },
      android: {
        elevation: 4,
      },
      default: {
        borderColor: "#66afe9",
        outline: 0,
        WebkitBoxShadow:
          "inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)",
        boxShadow:
          "inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)",
      },
    })
  );
  const textInputRef = useRef(null);
  const [iValue, setIValue] = useState(value || "");

  if (
    [
      "First Name",
      "Nickname",
      "Middle Name",
      "Last Name",
      "Employer Name",
      "HR Contact Person",
      "Payor Name",
      "Name",
    ].includes(props["label"])
  ) {
    autoCapitalize = "words";
  }

  useEffect(() => {
    setIValue(value);
  }, [value]);

  return (
    <TextInput
      ref={textInputRef}
      {...props}
      style={[
        style,
        InputStyle && web && hoverStyle,
        {
          fontFamily: web
            ? `"Helvetica Neue",Helvetica,Arial,sans-serif`
            : "Regular",
        },
        web && { outline: "none" },
        props["multiline"] && { height: 70 },
      ]}
      onChangeText={(text) => {
        if (
          props["charLength"] &&
          props["charLength"] < text?.toString().length
        ) {
          return;
        }

        if (keyboardType == "float" || isCurrency) {
          text = text
            .replace(/[^\d.]/g, "")
            .split(".")
            .slice(0, 2)
            .join(".");
        } else if (["numeric", "phone-pad"].includes(keyboardType)) {
          text = text.replace(/\D/g, "");
        } else if (placeholder.includes("MM/DD/YYYY") && false) {
          text = text.replace(/[^0-9\/]/g, "");
          if (text.length > 2 && text[2] !== "/") {
            text = text.slice(0, 2) + "/" + text.slice(2);
          }
          if (text.length > 5 && text[5] !== "/") {
            text = text.slice(0, 5) + "/" + text.slice(5);
          }
        }

        setIValue(text);
        onChangeText(text);
      }}
      value={
        (isCurrency || formatZero) && isFocused // For Amount Field - Remove formatting
          ? cleanValue(iValue) == 0
            ? ""
            : iValue?.toString()?.replaceAll("$", "").replaceAll(",", "")
          : (keyboardType == "phone-pad" || maxLength == 10) && isFocused // For Cellphone Field - Remove formatting
          ? iValue?.toString().replace(/[(),\- ]/g, "")
          : maxLength == 9 && isFocused // For SSN Field - Remove formatting
          ? iValue?.toString().replace(/-/g, "")
          : iValue || ""
      }
      maxLength={maxLength ? maxLength + (!isFocused ? 5 : 0) : null}
      placeholder={placeholder || ""}
      keyboardType={
        keyboardType == "float" ? "numeric" : keyboardType || "default"
      }
      autoCapitalize={autoCapitalize}
      secureTextEntry={secureTextEntry}
      placeholderTextColor="#999"
      onBlur={(e) => {
        let val = iValue;
        if (web && autoCapitalize === "words") {
          val = capitalizeFirstLetter(val);
        }
        try {
          setIValue((val || "").toString().trim());
          onChangeText((val || "").toString().trim());
        } catch (e) {}

        onBlur(e);
        setIsFocused(false);
        setInputStyle(false);
      }}
      onFocus={(e) => {
        if (web) {
          setInputStyle(true);
        }
        setIsFocused(true);
        onFocus(e);
      }}
      onKeyPress={(e) => {
        if (web) {
          if (
            (e.keyCode === 32 && !value) ||
            ([109, 189].includes(e.keyCode) &&
              !["Email or Cell Phone", "Email Address"].includes(placeholder))
          ) {
            e.preventDefault();
          }
        }
        onKeyPress(e);
      }}
    />
  );
}
